import React from 'react';
import { Section, SectionTitle } from 'react-scale/components';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type Props = {
  title: string;
  subtitle: string;
  overtitle: string;
  text: any;
  bg: string;
  paddingTop?: boolean | number;
  paddingBottom?: boolean | number;
};

export default function TextBlock({
  title,
  subtitle,
  overtitle,
  text,
  bg = 'black',
  paddingTop,
  paddingBottom
}: Props) {
  return (
    <Section bg={bg} paddingTop={paddingTop} paddingBottom={paddingBottom}>
      {/* @ts-ignore */}
      <SectionTitle title={title} subtitle={subtitle} overtitle={overtitle} marginBottom={false} />
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        children={text}
        className="max-w-full mt-5 text-xl leading-relaxed prose text-white"
      />
    </Section>
  );
}
